<pr-multi-step-treatment
  [stepDragDrop]="stepDragDrop"
  [steps]="treatmentSteps$ | async"
  [plan]="treatmentPlan$ | async"
  [disabled]="disabled"
  (stepDelete)="deleteStep($event)"
  (stepAdd)="addStep($event)"
  (stepChange)="updateStep($event)"
  (selectChild)="generateChildPlan()"
  (moveTreatmentsToStep)="moveTreatmentsToStep($event)"
  (updateChartable)="updateChartable($event)"
/>
